import { createFileRoute } from '@tanstack/react-router';
import FulfillmentAdmin from 'containers/FulfillmentAdmin';

export const Route = createFileRoute('/_authenticated/fulfillmentAdmin')({
  component: FulfillmentAdmin,
});
